namespace Gamification.Gamification {
    export namespace UtentiDelegatiService {
        export const baseUrl = 'Gamification/UtentiDelegati';

        export declare function Create(request: Serenity.SaveRequest<UtentiDelegatiRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<UtentiDelegatiRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<UtentiDelegatiRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<UtentiDelegatiRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/UtentiDelegati/Create",
            Update = "Gamification/UtentiDelegati/Update",
            Delete = "Gamification/UtentiDelegati/Delete",
            Retrieve = "Gamification/UtentiDelegati/Retrieve",
            List = "Gamification/UtentiDelegati/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>UtentiDelegatiService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
